import React, { useRef } from "react";
import MainImage5 from "../../assets/VA/VAMAIN4.jpg";
import AboutImage from "../../assets/AboutImage7.jpg";

// Importing images from the assets folder
import TestimonyImage1 from "../../assets/VisibilityAudit/VisibilityAudit4.png";
import TestimonyImage2 from "../../assets/VisibilityAudit/VisibilityAudit2.png";
// import TestimonyImage3 from '../assets/VisibilityAudit/VisibilityAudit3.png';
import TestimonyImage4 from "../../assets/VisibilityAudit/VisibilityAudit11.png";
import TestimonyImage5 from "../../assets/VisibilityAudit/VisibilityAudit5.png";
import TestimonyImage6 from "../../assets/VisibilityAudit/VisibilityAudit6.png";
import TestimonyImage7 from "../../assets/VisibilityAudit/VisibilityAudit7.png";
import TestimonyImage8 from "../../assets/VisibilityAudit/VisibilityAudit8.png";
import TestimonyImage9 from "../../assets/VisibilityAudit/VisibilityAudit9.png";
import TestimonyImage10 from "../../assets/VisibilityAudit/VisibilityAudit10.png";
import TestimonyImage11 from "../../assets/VisibilityAudit/VisibilityAudit.png";
import SmallTestimony from "../../components/SmallTestimony";
import Footer from "../../components/Footer";
import About from "../../components/About";
import NavLite from "../../components/NavLite";

function EliteVisible() {
  const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  // Array of testimonials with image sources
  const testimonials = [
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    // { image: TestimonyImage3, name: "James Smith", role: "Marketing Director" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
    { image: TestimonyImage10, name: "Linda Green", role: "COO" },
    { image: TestimonyImage11, name: "Linda Green", role: "COO" },
  ];

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
      <title>Elite Visible™ Program | High-Impact SEO for Women Entrepreneurs | Her Growth Co</title>
      <meta
  name="description"
  content="Elite Visible is a premium SEO service helping female founders become thought leaders online through expert strategy, content, and visibility systems."
/>
<meta
  name="keywords"
  content="high-end website design texas, premium web design services, austin custom website development, conversion-focused web design, mobile responsive web design austin, website design for coaches, ux/ui website design austin, brand-first website design, premium branding website texas, website design for consultants, creative web design agency austin, bespoke web development texas, web design for personal brands austin, austin expert wordpress designer, strategic website design for leads, lead generation web design austin, custom web graphics austin, lightning-fast websites austin tx, mobile-first web design texas, expert website builder for women entrepreneurs, website design for experts texas, web designer for thought leaders, seo-ready website builds, visually engaging websites texas, ux design for female-led businesses, web design austin tx, seo services austin, premium website design austin, austin seo expert, custom web design for consultants austin, austin seo for creatives, authority website design austin, high-end seo agency austin, austin local seo services, web design for coaches austin, conversion-focused web design austin, bespoke websites austin, seo for service providers austin, austin high-ticket web design, expert seo strategy austin, website design agency austin, austin tx web design for women, seo for women-led businesses austin, women entrepreneur seo austin, austin website agency for female founders, mobile-first web design austin, seo content strategy austin, interactive website design austin tx, austin digital marketing agency, high-converting websites austin, seo consultant for women austin, austin brand visibility seo."
/>

      <section>
        <div
          className="relative bg-cover bg-center h-auto"
          style={{ backgroundImage: `url(${MainImage5})` }}
        >
<NavLite/>

          <div className="flex flex-col max-w-2xl py-12 md:py-16 lg:py-10 gap-10 ml-10 ">
            <div className="flex flex-col items-start gap-y-5 bg-black/1 backdrop-blur-sm">
              {" "}
              {/* items-start here */}
              <h1 className="text-left text-3xl font-bold md:text-5xl text-white uppercase ">
                {" "}
                {/* text-left here */}
                <span className=" text-white">
                  {" "}
                  Elevate Your Brand.
                </span>{" "}
                 Attract Premium Clients. 
                <span className="bg-[#CFF098] text-black"> $3999</span> Elite & Visible Package.
              </h1>
              <p className="text-left text-white bg-black/1 backdrop-blur-sm max-w-2xl text-xl font-bold italic">
                {" "}
                {/* text-left here */}
                Transform your website into a powerful client-generating tool. Establish your authority and attract high-value clients with our comprehensive, custom-designed solution.
              </p>
            </div>
            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="https://cal.com/woaomwebdesign/15min"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-6 py-3 text-black border-[1px] border-black shadow-md"
              >
                <p>Book Your Elite & Visible Consultation</p>
              </a>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center rounded-md px-3 py-1">
                <p className="text-sm uppercase mb-12 text-black">
                Elite & Visible Package
                </p>
              </div>
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl">
              Your Premium 
                <span className="bg-[#CFF098] text-black font-semibold italic">
                 Online Presence
                </span>
                : What's Included in Your Elite & Visible Package.
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
              This package is designed for driven women in law, consulting, and finance, providing a complete online transformation to reflect your expertise and attract your ideal clients.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                Custom, High-Authority Website Design
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We create visually stunning, professional websites, tailored to your brand, with mobile-responsive design, user-friendly navigation, and fast loading speeds to ensure a seamless client experience.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 ">
                <h3 className="text-xl font-semibold text-black uppercase">
                Local SEO Domination Setup
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We boost local visibility through optimized Google Business Profiles, targeted keywords, consistent citations, geo-targeted content, and Google Maps optimization.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                SEO-Optimized Service Pages
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We enhance search engine visibility through keyword-rich content, on-page SEO optimization, and strategic internal linking.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                Authority-Building "About" Page
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We build your credibility with a compelling narrative, showcase your expertise and achievements, and strategically place client testimonials.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                Content Marketing Foundation
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We establish your thought leadership with an SEO-friendly blog setup, an initial optimized post, and strategic content recommendations.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                Analytics & Performance Tracking
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                We provide data-driven insights with Google Analytics setup, track SEO progress with a ranking dashboard, and deliver monthly performance reports.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                Training and Support
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                Training videos on website maintenance for client empowerment.
                60 days of post launch support.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                LinkedIn Content Optimization.
                </h3>
                <p className="text-black text-lg mb-10 font-light">We strategically optimize your LinkedIn profile to enhance visibility and develop a comprehensive content calendar.
                  <br />{" "}
                  <span className="text-black bg-[#CFF098] text-sm font-light max-w-[240px]">
                    *Limited Time Offer - All April 2025
                  </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10">
            <a href="https://cal.com/woaomwebdesign/15min">
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
              Book a Elite & Visible Consultation →
              </button>
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
              No prep needed! Just come talk & we’ll figure it out together.
              </p>
            </div>
          </div>
        </section>

        <section>
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-10 ">
            <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              <h2 className="text-3xl font-semibold max-w-lg mt-8 sm:mt-28">
                <span className="bg-[#CFF098] text-black italic">
                  More Packages
                </span>{" "}
                We Offer.
              </h2>
              <div className="space-y-4 ">


                <h4 className="pt-4 font-semibold">Local SEO Accelerator Package ($499):</h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  You will get targeted local SEO optimization, including GBP
                  optimization, citation building, keyword research, review
                  management, content optimization, performance reporting, and a
                  strategy session, to quickly boost local visibility for
                  professional service providers.
                </p>
                <a href="/localseo">
                <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-2">
                  View Local SEO Accelerator Package →
                </button>
                </a>
                <h4 className="font-semibold">Visibility Audit Package ($99):</h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  You will get a concise report and personalized Loom walkthrough, analyzing website speed, mobile responsiveness, on-page and local SEO, and UX, providing actionable recommendations for improved online performance.
                </p>
                <a href="visibilityaudit">
                <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-2">
                View Visibility Audit Package →
                </button>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"></div>
          </div>
        </section>

        {/* Our Projects */}

        <section className="">
          <div className="bg-[#F7F3F2] h-auto">
            <h2 className="text-center text-2xl font-bold md:text-3xl text-black pt-16 mb-16 uppercase">
              Our{" "}
              <span className="bg-[#CFF098] text-black italic">
                Elite & Visibility Audit
              </span>{" "}
              Projects
            </h2>

            {/* Left Arrow Button */}
            <button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              {/* <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg> */}
            </button>

            <div className="relative flex items-center justify-center">
              <div
                ref={containerRef}
                className="flex overflow-x-auto gap-28 py-6 scroll-smooth scroll-m-0  max-w-[1040px] w-full" // Limit the width to 4 items
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="min-w-[650px]">
                    <img
                      className="object-cover w-full h-auto"
                      src={testimonial.image} // Display the image from assets
                      alt={`Testimonial ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow Button */}
            <button
              className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollRight}
            >
              {/* Right Arrow SVG */}
              {/* <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg> */}
            </button>
          </div>
        </section>

        <SmallTestimony />

        <section
  className="bg-cover bg-center"
  style={{ backgroundImage: `url(${AboutImage})` }} // Replace AboutImage with your Elite & Visible focused image
>
  <div className="">
    <div className="mx-auto w-full text-center bg-[#000000] bg-opacity-60 p-6">
      <h2 className="mx-auto mb-2 max-w-3xl flex-col text-3xl font-bold md:mb-6 md:text-4xl lg:mb-6  text-white ">
        Ready to Become <span className="bg-[#CFF098] text-black italic">Elite & Visible</span>?
      </h2>
      <p className="mx-auto mb-2 max-w-xl text-sm text-gray-300 sm:text-base md:mb-4">
        Elevate your brand and attract premium clients with a website that truly reflects your expertise. Schedule your Elite & Visible consultation today.
      </p>
      <a
        href="https://cal.com/woaomwebdesign/15min" // Replace with your consultation booking URL
        className="mb-4 inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
      >
        Schedule Your Elite & Visible Consultation
      </a>
    </div>
  </div>
</section>

        <About />

        <Footer />
      </section>
    </main>
  );
}

export default EliteVisible;
